var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntegrityBgImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 779,
    height: 372,
    viewBox: "0 0 779 372",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M779 230.822L775.862 231.959L779 231.622V232.759L766.468 234.128L779 229.601V230.822Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.25
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M779 146.962L742.794 164.5L779 193.114V194.587L740.646 164.269L779 145.678V146.962Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.25
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M779 194.588L743.152 166.248L771.481 232.317L779 229.601V230.822L771.376 233.581L770.849 233.77L740.309 162.542L779 193.114V194.588Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.48
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M585.377 300.239L586.64 228.001L576.594 236.402L577.331 237.286L585.461 230.485L584.345 293.628L576.025 240.76L574.888 240.949L584.239 300.323L585.377 300.239Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.03
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M578.047 240.57C577.815 239.16 576.489 238.191 575.077 238.402C573.666 238.633 572.697 239.96 572.908 241.371C573.14 242.781 574.467 243.75 575.878 243.539C577.289 243.329 578.258 241.981 578.047 240.57Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.32
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M578.721 238.739C577.626 239.665 575.983 239.518 575.056 238.423C574.13 237.328 574.277 235.686 575.372 234.78C576.468 233.854 578.11 234.001 579.037 235.096C579.964 236.191 579.816 237.833 578.721 238.76V238.739Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.38
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M537.355 372.267L585.629 349.317L586.114 350.37L540.03 372.267H537.355Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.38
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M586.325 372.267L587.399 351.212L588.536 351.275L587.483 372.267H586.325Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.02
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M590.558 351.507C590.621 350.075 589.526 348.854 588.094 348.791C586.661 348.728 585.44 349.823 585.377 351.255C585.313 352.686 586.409 353.907 587.841 353.971C589.273 354.034 590.495 352.939 590.558 351.507Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.42
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M584.639 347.549C585.924 346.938 587.483 347.486 588.094 348.77C588.704 350.054 588.157 351.612 586.872 352.223C585.587 352.833 584.029 352.286 583.418 351.002C582.807 349.717 583.355 348.159 584.639 347.549Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.3
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M779 145.678V146.962L741.973 164.901L741.405 165.195L715.751 90.9149L716.825 90.5359L742.058 163.595L779 145.678Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.3
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M779 119.086L717.457 89.9885L717.962 88.9358L779 117.802V119.086Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.7
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M718.931 87.1668C717.646 86.5562 716.088 87.1036 715.477 88.409C714.866 89.6933 715.414 91.2514 716.72 91.862C718.004 92.4726 719.563 91.9251 720.174 90.6198C720.785 89.3354 720.237 87.7774 718.931 87.1668Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.09
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M713.876 91.694C713.413 90.3465 714.129 88.8727 715.477 88.3884C716.825 87.9252 718.299 88.641 718.784 89.9885C719.247 91.336 718.531 92.8099 717.183 93.2941C715.835 93.7573 714.361 93.0415 713.876 91.694Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.4
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M730.873 303.649L771.881 232.948L771.565 232.632L688.391 150.225L727.967 303.249L729.083 302.955L690.561 153.994L770.449 233.138L729.883 303.06L730.873 303.649Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.64
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M725.987 303.629C726.345 305.018 727.756 305.84 729.146 305.482C730.537 305.124 731.358 303.713 731 302.323C730.642 300.934 729.231 300.113 727.841 300.471C726.45 300.829 725.629 302.239 725.987 303.629Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.06
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M732.685 304.535C731.968 305.777 730.368 306.198 729.146 305.482C727.903 304.766 727.482 303.166 728.198 301.945C728.914 300.703 730.515 300.281 731.737 300.997C732.979 301.713 733.401 303.313 732.685 304.535Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.29
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M729.083 302.955L689.823 151.152L584.977 229.328L726.703 304.829L727.229 303.818L587.125 229.159L689.128 153.089L727.967 303.25L729.083 302.955Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.57
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M725.629 306.555C726.892 307.229 728.472 306.745 729.146 305.482C729.82 304.218 729.336 302.639 728.072 301.965C726.808 301.292 725.229 301.776 724.555 303.039C723.881 304.302 724.365 305.882 725.629 306.555Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.06
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M731 302.324C731.358 303.713 730.515 305.124 729.146 305.482C727.756 305.84 726.345 304.998 725.987 303.629C725.629 302.261 726.471 300.829 727.84 300.471C729.23 300.113 730.641 300.955 731 302.324Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.11
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M691.213 151.952L594.497 127.739L591.042 194.229L592.201 194.293L595.592 129.192L687.738 152.268L593.507 195.156L593.97 196.208L691.213 151.952Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.39
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M592.791 193.282C591.485 193.872 590.916 195.409 591.506 196.714C592.096 198.019 593.633 198.588 594.939 197.998C596.245 197.409 596.813 195.872 596.224 194.566C595.634 193.261 594.096 192.693 592.791 193.282Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.16
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M594.223 194.25C594.139 195.682 592.938 196.777 591.506 196.714C590.074 196.651 588.978 195.429 589.042 193.998C589.105 192.566 590.326 191.471 591.759 191.534C593.191 191.619 594.286 192.819 594.223 194.25Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.36
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M694.12 149.362L593.507 195.156L593.97 196.208L684.832 154.857L586.851 227.917L591.653 199.24L590.516 199.051L585.25 230.548L694.12 149.362Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.53
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M592.791 193.282C591.485 193.872 590.916 195.409 591.506 196.714C592.096 198.019 593.633 198.588 594.939 197.998C596.245 197.409 596.813 195.872 596.224 194.566C595.634 193.261 594.096 192.693 592.791 193.282Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.34
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M588.515 198.84C588.747 197.43 590.095 196.482 591.506 196.714C592.917 196.945 593.865 198.293 593.633 199.703C593.402 201.114 592.054 202.062 590.643 201.83C589.231 201.598 588.284 200.251 588.515 198.84Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M488.871 372.267L498.138 322.852L499.275 323.062L490.029 372.267H488.871Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M537.355 372.267L586.535 348.896L501.339 321.841L501.676 320.725L589.652 348.664L540.03 372.267H537.355Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.65
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M502.413 318.851C501.044 318.409 499.591 319.167 499.149 320.535C498.706 321.904 499.465 323.357 500.834 323.799C502.203 324.241 503.656 323.483 504.098 322.114C504.541 320.746 503.782 319.293 502.413 318.851Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.13
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M496.137 322.599C496.411 321.189 497.759 320.262 499.17 320.536C500.581 320.81 501.508 322.157 501.234 323.568C500.96 324.979 499.612 325.905 498.201 325.631C496.79 325.358 495.863 324.01 496.137 322.599Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.26
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M488.871 372.267L498.307 322.009L482.194 335.463L481.457 334.579L500.013 319.062L490.029 372.267H488.871Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.26
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M482.089 372.267L479.561 339.106L480.699 339.021L483.247 372.267H482.089Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.6
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M482.72 338.98C482.615 337.548 481.373 336.474 479.94 336.601C478.508 336.706 477.434 337.948 477.56 339.38C477.687 340.811 478.908 341.885 480.34 341.759C481.773 341.654 482.847 340.411 482.72 338.98Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.67
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M483.605 336.937C482.51 337.863 480.867 337.716 479.94 336.621C479.014 335.526 479.161 333.884 480.256 332.979C481.351 332.073 482.994 332.2 483.921 333.294C484.848 334.389 484.7 336.032 483.605 336.958V336.937Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.3
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M588.936 349.654L578.826 314.303L501.571 319.798L501.655 320.851L501.339 321.841L588.957 349.654H588.936ZM577.984 315.503L587.251 347.906L502.203 320.893L578.005 315.503H577.984Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.28
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M501.571 317.756C500.139 317.862 499.065 319.104 499.17 320.536C499.275 321.967 500.518 323.041 501.95 322.936C503.382 322.83 504.457 321.588 504.351 320.157C504.246 318.725 503.003 317.651 501.571 317.756Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.68
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M500.834 323.799C499.465 323.357 498.706 321.904 499.149 320.535C499.591 319.167 501.044 318.409 502.413 318.851C503.782 319.293 504.541 320.746 504.098 322.114C503.656 323.483 502.203 324.241 500.834 323.799Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.03
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M440.428 372.267H438.09L433.288 369.551L433.857 368.54L440.428 372.267Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.03
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M459.005 372.267L449.59 362.497L433.941 367.614L433.583 366.519L449.906 361.192L460.605 372.267H459.005Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.14
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M434.973 366.856C433.73 366.14 432.15 366.582 431.434 367.824C430.718 369.066 431.16 370.645 432.403 371.361C433.646 372.077 435.225 371.635 435.941 370.393C436.658 369.151 436.215 367.571 434.973 366.856Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.63
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M434.699 369.488C433.33 369.93 431.877 369.193 431.434 367.824C430.992 366.456 431.729 365.003 433.098 364.561C434.467 364.119 435.921 364.856 436.363 366.224C436.805 367.593 436.068 369.045 434.699 369.488Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.06
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M438.09 372.267L433.393 369.614L435.289 372.267H433.878L432.382 370.161L433.309 369.53L433.857 368.54L440.428 372.267H438.09Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.63
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M434.973 366.856C433.73 366.14 432.15 366.582 431.434 367.824C430.718 369.066 431.16 370.645 432.403 371.361C433.646 372.077 435.225 371.635 435.941 370.393C436.658 369.151 436.215 367.571 434.973 366.856Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.13
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M418.081 372.267L428.928 368.161L429.328 369.235L421.325 372.267H418.081Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.17
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M428.086 366.329C429.434 365.824 430.929 366.497 431.434 367.845C431.94 369.192 431.266 370.687 429.918 371.193C428.57 371.698 427.075 371.024 426.569 369.677C426.064 368.329 426.738 366.834 428.086 366.329Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.43
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M472.232 372.267H470.926L462.333 355.318L477.876 338.053L478.719 338.811L463.723 355.507L472.232 372.267Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.43
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M482.089 372.267L479.561 339.106L480.699 339.021L483.247 372.267H482.089Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.47
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M482.72 338.98C482.615 337.548 481.373 336.474 479.94 336.601C478.508 336.706 477.434 337.948 477.56 339.38C477.687 340.811 478.908 341.885 480.34 341.759C481.773 341.654 482.847 340.411 482.72 338.98Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.05
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M476.276 336.79C477.223 335.716 478.866 335.632 479.94 336.6C481.015 337.569 481.099 339.19 480.13 340.264C479.182 341.338 477.539 341.422 476.465 340.453C475.391 339.485 475.307 337.864 476.276 336.79Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.06
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M470.926 372.267L463.617 357.865L464.649 357.339L472.232 372.267H470.926Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.06
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M460.605 372.267H459.005L448.79 361.676L460.563 355.97L461.048 357.002L450.706 362.013L460.605 372.267Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.39
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M466.503 356.539C465.85 355.255 464.291 354.75 463.006 355.402C461.722 356.055 461.216 357.613 461.869 358.897C462.522 360.182 464.081 360.687 465.365 360.034C466.65 359.382 467.156 357.824 466.503 356.539Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.69
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M459.552 354.202C460.837 353.57 462.396 354.117 463.027 355.402C463.659 356.686 463.112 358.244 461.827 358.876C460.542 359.507 458.984 358.96 458.352 357.676C457.72 356.391 458.267 354.833 459.552 354.202Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.23
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M689.339 152.667L689.697 151.594L603.932 114.243L603.469 115.296L682.873 149.867L595.845 128.076L600.984 116.285L599.931 115.822L594.244 128.855L594.897 129.023L689.339 152.667Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.32
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M604.859 112.454C603.553 111.885 602.016 112.475 601.447 113.801C600.878 115.107 601.468 116.644 602.795 117.212C604.101 117.781 605.638 117.191 606.207 115.865C606.776 114.559 606.186 113.022 604.859 112.454Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.11
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M598.014 115.127C598.582 113.822 600.12 113.211 601.426 113.78C602.732 114.348 603.342 115.885 602.774 117.191C602.205 118.496 600.668 119.107 599.362 118.538C598.056 117.97 597.445 116.433 598.014 115.127Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.24
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M586.409 230.569L591.653 199.24L590.516 199.051L585.692 227.916L575.33 215.536L590.284 198.924L589.42 198.166L573.813 215.515L586.409 230.569Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.3
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M593.633 199.703C593.865 198.293 592.917 196.945 591.506 196.714C590.095 196.482 588.747 197.43 588.515 198.84C588.284 200.251 589.231 201.598 590.643 201.83C592.054 202.062 593.402 201.114 593.633 199.703Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.03
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M587.841 196.903C588.789 195.829 590.432 195.745 591.506 196.714C592.58 197.661 592.664 199.303 591.695 200.377C590.748 201.451 589.105 201.535 588.031 200.567C586.956 199.619 586.872 197.977 587.841 196.903Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.12
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M586.872 229.306L576.594 217.032L575.709 217.768L585.251 229.159L575.625 237.202L575.204 217.979L574.067 218L574.53 239.623L586.872 229.306Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.58
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M578.237 215.853C577.31 214.758 575.688 214.61 574.593 215.537C573.498 216.463 573.35 218.084 574.277 219.179C575.204 220.274 576.826 220.421 577.921 219.495C579.016 218.569 579.164 216.947 578.237 215.853Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.32
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M572.044 218.169C572.023 216.737 573.14 215.558 574.572 215.516C576.004 215.474 577.184 216.611 577.226 218.042C577.247 219.474 576.131 220.653 574.698 220.695C573.266 220.737 572.087 219.6 572.044 218.169Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.48
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M727.609 307.503L726.871 306.619L693.488 334.537L589.273 231.602L726.703 304.829L727.23 303.819L582.849 226.885L693.425 336.095L727.609 307.503Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.32
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M725.629 306.555C726.892 307.229 728.472 306.745 729.146 305.482C729.82 304.218 729.336 302.639 728.072 301.965C726.808 301.292 725.229 301.776 724.555 303.039C723.881 304.302 724.365 305.882 725.629 306.555Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.22
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M725.481 305.166C726.577 304.239 728.219 304.387 729.146 305.481C730.073 306.576 729.925 308.219 728.83 309.145C727.735 310.071 726.092 309.924 725.165 308.829C724.239 307.734 724.386 306.092 725.481 305.166Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.28
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M695.573 336.6L588.22 230.569L587.399 231.369L691.34 334.031L585.377 299.818L586.578 231.706L585.44 231.685L584.219 300.66L584.619 300.786L695.573 336.6Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.25
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M588.599 231.875C588.62 230.443 587.483 229.264 586.051 229.243C584.619 229.222 583.439 230.359 583.418 231.791C583.397 233.222 584.534 234.402 585.967 234.423C587.399 234.444 588.578 233.307 588.599 231.875Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.57
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M586.072 232.907C585.061 231.896 585.04 230.254 586.051 229.243C587.062 228.233 588.705 228.212 589.716 229.222C590.727 230.233 590.748 231.875 589.737 232.886C588.726 233.896 587.083 233.917 586.072 232.907Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.15
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M779 232.759L772.745 233.454L779 237.896V239.307L769.606 232.633L779 231.622V232.759Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.43
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M779 239.308L771.354 233.876L730.389 304.492L779 288.933V290.154L729.315 306.029L727.882 306.493L770.681 232.76L770.996 232.212L779 237.897V239.308Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.65
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M779 2.46432L731.8 61.1644L779 58.6589V59.8169L729.294 62.4487L779 0.632587V2.46432Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.03
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M575.667 238.844L575.204 217.979L574.067 218L574.488 238.002L550.646 245.16L573.435 217.79L572.55 217.053L547.318 247.35L575.667 238.844Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.28
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M577.226 218.063C577.205 216.632 576.004 215.495 574.572 215.537C573.14 215.579 572.002 216.758 572.045 218.19C572.066 219.621 573.266 220.758 574.698 220.716C576.131 220.674 577.268 219.495 577.226 218.063Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.07
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M570.928 215.852C571.855 214.758 573.477 214.61 574.572 215.515C575.667 216.442 575.815 218.063 574.909 219.158C573.982 220.253 572.36 220.4 571.265 219.495C570.17 218.568 570.022 216.947 570.928 215.852Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.3
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M585.777 302.745L575.541 237.686L551.172 244.992L551.488 246.087L574.614 239.16L583.818 297.734L550.814 247.982L549.845 248.613L585.777 302.745Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.6
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M550.709 243.013C549.34 243.434 548.56 244.866 548.961 246.235C549.382 247.603 550.814 248.382 552.183 247.982C553.552 247.561 554.331 246.129 553.931 244.761C553.51 243.392 552.078 242.613 550.709 243.013Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.48
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M578.405 316.346L585.461 300.176L585.293 299.923L550.814 247.982L550.14 248.424L549.403 248.74L578.405 316.346ZM584.155 300.281L578.426 313.44L552.015 251.835L584.176 300.281H584.155Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.1
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M552.562 246.971C551.762 245.771 550.161 245.455 548.96 246.234C547.76 247.034 547.444 248.634 548.223 249.834C549.024 251.035 550.624 251.35 551.825 250.571C553.025 249.792 553.341 248.171 552.562 246.971Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.22
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M547.613 249.666C547.044 248.34 547.655 246.824 548.982 246.255C550.308 245.687 551.825 246.297 552.394 247.624C552.962 248.95 552.351 250.466 551.025 251.035C549.719 251.603 548.181 250.992 547.613 249.666Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.04
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M579.269 315.42L550.477 248.298L549.424 248.74L577.563 314.388L500.286 319.883L548.076 248.613L547.128 247.982L498.033 321.188L579.269 315.42Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.24
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M552.372 247.603C551.804 246.276 550.287 245.687 548.96 246.234C547.655 246.803 547.044 248.319 547.591 249.645C548.139 250.972 549.677 251.561 551.003 251.014C552.33 250.445 552.92 248.929 552.372 247.603Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.08
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M545.38 246.971C546.18 245.771 547.781 245.455 548.982 246.255C550.182 247.055 550.498 248.655 549.698 249.855C548.897 251.034 547.297 251.371 546.096 250.571C544.917 249.771 544.58 248.171 545.38 246.971Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.54
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M715.224 157.3L716.067 87.7566L692.224 90.3674L692.33 91.5043L714.887 89.041L714.129 151.426L691.256 93.2729L690.203 93.694L715.224 157.3Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.69
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M693.193 92.6621C692.667 91.3357 691.171 90.683 689.823 91.1883C688.496 91.7147 687.844 93.2096 688.349 94.5571C688.876 95.8835 690.371 96.5362 691.719 96.0309C693.046 95.5045 693.699 94.0096 693.193 92.6621Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.21
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M692.688 93.4831C691.256 93.6304 689.992 92.5988 689.823 91.1881C689.676 89.7564 690.708 88.4931 692.119 88.3247C693.551 88.1773 694.815 89.209 694.983 90.6196C695.152 92.0303 694.099 93.3146 692.688 93.4831Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.19
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M742.668 165.342L716.825 90.5354L715.877 90.8723H714.866L714.087 154.752L714.466 154.899L742.647 165.363L742.668 165.342ZM716.024 91.6934L740.793 163.405L715.266 153.931L716.024 91.6724V91.6934Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.64
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M718.784 90.0096C718.32 88.6621 716.846 87.9462 715.477 88.4094C714.129 88.8726 713.413 90.3464 713.876 91.715C714.34 93.0625 715.814 93.7783 717.183 93.3151C718.531 92.8519 719.247 91.3781 718.784 90.0096Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.02
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M712.844 90.9566C712.844 89.5249 714.045 88.3879 715.477 88.3879C716.909 88.3879 718.046 89.588 718.046 91.0197C718.046 92.4514 716.846 93.5884 715.414 93.5884C713.982 93.5884 712.844 92.3883 712.844 90.9566Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.64
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M715.561 155.005L691.277 93.273L690.308 93.6519H689.255L688.918 152.626L715.582 155.005H715.561ZM690.392 94.1783L713.813 153.7L690.055 151.573L690.392 94.1573V94.1783Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.26
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M688.37 94.557C687.844 93.2306 688.496 91.7147 689.844 91.1883C691.171 90.6619 692.688 91.3146 693.214 92.6621C693.741 93.9886 693.088 95.5045 691.74 96.0309C690.413 96.5572 688.897 95.9045 688.37 94.557Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.03
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M773.777 237.665L743.237 166.438L742.162 166.88L768.574 228.422L716.235 155.552L739.214 164.079L739.614 163.006L713.118 153.173L773.777 237.665Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.37
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M740.204 161.048C741.552 161.553 742.226 163.048 741.741 164.374C741.257 165.701 739.74 166.395 738.413 165.911C737.065 165.406 736.391 163.911 736.876 162.585C737.381 161.237 738.877 160.563 740.204 161.048Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.69
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M770.196 230.717L714.992 153.826L687.928 151.405L689.065 152.52L769.017 231.707L769.564 231.159L770.196 230.696V230.717ZM714.361 154.921L766.7 227.811L691.003 152.836L714.361 154.921Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.42
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M767.5 233.054C768.511 234.065 770.154 234.065 771.165 233.054C772.176 232.043 772.176 230.401 771.165 229.391C770.154 228.38 768.511 228.38 767.5 229.391C766.489 230.401 766.489 232.043 767.5 233.054Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.37
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M771.755 229.432C772.597 230.59 772.323 232.211 771.165 233.054C770.007 233.896 768.385 233.622 767.542 232.464C766.7 231.306 766.974 229.685 768.132 228.843C769.291 228 770.912 228.274 771.755 229.432Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.6
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M779 113.59V114.938L723.207 80.5559L723.818 79.5874L779 113.59Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.6
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M779 61.2067L723.944 78.5767L723.607 77.4818L779 59.9855V61.2067Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.41
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M723.101 75.5237C721.732 75.9448 720.974 77.4186 721.416 78.7872C721.838 80.1557 723.312 80.9137 724.681 80.4715C726.05 80.0504 726.808 78.5766 726.366 77.2081C725.945 75.8395 724.47 75.0815 723.101 75.5237Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.15
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M722.259 82.3457C721.037 81.5877 720.658 79.9875 721.416 78.7874C722.175 77.5873 723.775 77.1873 724.976 77.9453C726.198 78.7032 726.577 80.3033 725.818 81.5035C725.06 82.7246 723.46 83.1036 722.259 82.3457Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.18
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M779 61.2067L723.944 78.5767L723.607 77.4818L779 60.0066V61.2067Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.18
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M779 59.8174L730.915 62.365L723.101 76.8716L722.069 76.3242L730.199 61.2491L779 58.6594V59.8174Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.68
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M723.101 75.5237C721.732 75.9448 720.974 77.4186 721.416 78.7872C721.838 80.1557 723.312 80.9137 724.681 80.4715C726.05 80.0504 726.808 78.5766 726.366 77.2081C725.945 75.8395 724.47 75.0815 723.101 75.5237Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M724.934 77.7136C724.26 78.9769 722.68 79.4401 721.416 78.7664C720.153 78.0926 719.689 76.5135 720.363 75.2502C721.037 73.9869 722.617 73.5237 723.881 74.1975C725.144 74.8712 725.608 76.4504 724.934 77.7136Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.37
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M724.997 77.9243C723.775 77.1663 722.175 77.5453 721.437 78.7665C720.7 79.9876 721.058 81.5877 722.28 82.3247C723.501 83.0826 725.102 82.7036 725.839 81.4825C726.598 80.2613 726.218 78.6612 724.997 77.9243Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.29
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M717.857 79.6292C718.615 78.4081 720.216 78.0291 721.416 78.7871C722.638 79.545 723.017 81.1452 722.259 82.3453C721.501 83.5664 719.9 83.9454 718.699 83.1874C717.478 82.4295 717.099 80.8293 717.857 79.6292Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.62
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M586.325 372.267L587.399 351.212L588.536 351.275L587.483 372.267H586.325Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.62
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M610.23 372.267L589.4 350.938L590.221 350.138L611.831 372.267H610.23Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.26
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M590.558 351.507C590.621 350.075 589.526 348.854 588.094 348.791C586.661 348.728 585.44 349.823 585.377 351.255C585.313 352.686 586.409 353.907 587.841 353.971C589.273 354.034 590.495 352.939 590.558 351.507Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.49
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M588.052 352.454C587.041 351.423 587.062 349.78 588.094 348.791C589.126 347.78 590.769 347.801 591.759 348.833C592.77 349.865 592.748 351.507 591.716 352.496C590.684 353.486 589.042 353.486 588.052 352.454Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.31
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M676.723 372.267L692.456 336.179L621.856 354.497L642.981 372.267H641.191L619.413 353.949L694.457 334.474L677.987 372.267H676.723Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.68
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M690.181 336.979C691.55 337.421 693.004 336.663 693.446 335.316C693.888 333.947 693.13 332.495 691.782 332.052C690.413 331.61 688.96 332.368 688.517 333.716C688.075 335.084 688.833 336.537 690.181 336.979Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.48
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M690.287 333.463C691.677 333.105 693.088 333.927 693.446 335.316C693.804 336.706 692.983 338.116 691.592 338.474C690.202 338.832 688.791 338.011 688.433 336.622C688.075 335.232 688.897 333.821 690.287 333.463Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.13
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M641.191 372.267L621.203 355.465L621.245 372.267H620.087L620.066 352.981L642.981 372.267H641.191Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.49
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M623.815 357.949L586.641 301.965L585.693 302.597L617.454 350.475L579.1 314.766L584.345 302.723L583.292 302.26L577.731 315.04L623.815 357.949Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.52
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M586.156 303.65C586.725 302.345 586.135 300.808 584.808 300.239C583.502 299.671 581.965 300.26 581.396 301.587C580.827 302.892 581.417 304.429 582.744 304.997C584.05 305.566 585.587 304.976 586.156 303.65Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.48
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M584.071 303.839C583.271 302.639 583.608 301.039 584.808 300.239C586.009 299.439 587.609 299.776 588.41 300.976C589.21 302.176 588.873 303.776 587.673 304.576C586.472 305.376 584.871 305.039 584.071 303.839Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.22
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M622.425 355.107L580.617 316.157L579.816 316.999L618.844 353.339L588.536 348.265L579.648 317.104L578.532 317.441L587.63 349.296L588.01 349.338L622.425 355.107Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.24
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M581.628 316.683C581.228 315.314 579.795 314.514 578.426 314.893C577.057 315.293 576.257 316.725 576.636 318.093C577.036 319.462 578.469 320.262 579.838 319.883C581.207 319.483 582.007 318.051 581.628 316.683Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.29
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M578.553 318.578C577.5 317.609 577.436 315.967 578.426 314.914C579.395 313.862 581.038 313.799 582.091 314.788C583.144 315.757 583.207 317.399 582.217 318.452C581.228 319.504 579.606 319.567 578.553 318.578Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.55
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M620.087 372.267L620.066 354.707L589.737 349.633L611.831 372.267H610.209L586.451 347.928L621.203 353.739L621.245 372.267H620.087Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.49
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M690.034 153.678L690.055 152.12L690.392 93.6727L689.234 93.6517L688.897 150.541L631.229 81.6085L687.296 91.3357L687.486 90.2198L628.343 79.9241L690.034 153.678Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.11
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M692.414 93.799C692.414 92.3673 691.277 91.2093 689.844 91.1882C688.412 91.1882 687.254 92.3252 687.233 93.7569C687.212 95.1886 688.37 96.3677 689.802 96.3677C691.235 96.3677 692.414 95.2307 692.414 93.799Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.65
  }, _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M687.717 88.1985C689.128 88.4511 690.076 89.7776 689.823 91.1882C689.571 92.5989 688.244 93.5463 686.833 93.2937C685.421 93.041 684.474 91.7146 684.726 90.3039C684.979 88.8933 686.306 87.9458 687.717 88.1985Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.09
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M691.466 153.615L631.797 82.2824L630.934 83.0193L687.464 150.604L602.374 113.569L628.617 83.0193L627.753 82.2614L600.499 114.012L601.194 114.327L691.466 153.615Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.65
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M633.441 81.0825C632.514 79.9876 630.892 79.8403 629.776 80.7667C628.659 81.6931 628.533 83.3143 629.46 84.4301C630.387 85.525 632.008 85.6724 633.125 84.746C634.22 83.8196 634.367 82.1984 633.441 81.1036V81.0825Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.25
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M626.132 81.04C627.058 79.9452 628.701 79.8189 629.796 80.7663C630.892 81.6927 631.018 83.335 630.07 84.4298C629.144 85.5246 627.501 85.651 626.405 84.7035C625.31 83.7771 625.184 82.1348 626.132 81.04Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.25
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M722.743 359.739L722.322 358.413L722.385 357.002L661.179 354.181L702.102 366.182L702.334 366.118L722.743 359.739ZM674.364 356.391L721.205 358.56L702.081 364.539L674.342 356.412L674.364 356.391Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.68
  }, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M722.006 361.381C723.986 361.466 725.671 359.929 725.755 357.95C725.839 355.97 724.323 354.286 722.322 354.202C720.342 354.118 718.657 355.655 718.573 357.634C718.489 359.613 720.026 361.297 722.006 361.381Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.4
  }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M721.269 355.592C723.164 355.002 725.186 356.055 725.776 357.95C726.366 359.845 725.313 361.866 723.417 362.455C721.522 363.045 719.5 361.992 718.91 360.097C718.32 358.202 719.373 356.181 721.269 355.592Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.35
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M779 236.612L769.796 245.897L779 256.487V258.93L767.605 245.813L779 234.338V236.612Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.64
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M779 258.93L768.975 247.371L727.23 356.392L779 332.137V333.905L724.323 359.508L767.964 245.561L768.427 244.339L779 256.488V258.93Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.25
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M725.903 359.845L726.513 358.245L768.216 249.329L766.742 248.761L725.629 356.076L667.919 252.467L765.331 246.845L765.246 245.266L665.286 251.035L725.903 359.845Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.6
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M764.909 242.466C766.889 242.36 768.595 243.855 768.701 245.855C768.806 247.834 767.31 249.54 765.31 249.645C763.33 249.75 761.624 248.256 761.518 246.255C761.413 244.255 762.908 242.571 764.909 242.466Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.25
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M722.322 358.603L722.406 357.002L668.551 354.518L667.434 254.888L723.417 355.36L724.807 354.581L665.771 248.614L666.992 356.055L667.729 356.076L722.322 358.603Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.16
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M722.006 361.381C723.986 361.466 725.671 359.929 725.755 357.95C725.839 355.97 724.323 354.286 722.322 354.202C720.342 354.118 718.657 355.655 718.573 357.634C718.489 359.613 720.026 361.297 722.006 361.381Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.57
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M727.166 353.065C728.135 354.791 727.503 356.981 725.776 357.95C724.049 358.918 721.858 358.286 720.889 356.56C719.921 354.833 720.553 352.644 722.28 351.675C724.007 350.707 726.197 351.338 727.166 353.065Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.48
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M394.197 342.538L434.257 250.719L416.923 256.13L417.386 257.646L431.413 253.288L396.387 333.506L413.869 261.415L412.31 261.036L392.68 342.033L394.197 342.538Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.03
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M416.544 262.257C417.007 260.32 415.827 258.383 413.89 257.92C411.952 257.456 410.014 258.635 409.551 260.572C409.088 262.509 410.267 264.446 412.205 264.91C414.143 265.373 416.08 264.194 416.544 262.257Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.32
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M418.397 260.278C416.502 260.867 414.48 259.815 413.89 257.92C413.3 256.025 414.353 254.003 416.249 253.414C418.144 252.824 420.166 253.877 420.756 255.772C421.346 257.667 420.293 259.688 418.397 260.278Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.3
  }, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M770.407 246.55L676.323 142.519L675.143 143.593L766.995 245.16L667.455 250.908L674.027 143.993L672.426 143.888L665.749 252.592L666.655 252.55L770.407 246.55Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.7
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M678.513 140.772C677.186 139.298 674.911 139.193 673.437 140.519C671.963 141.846 671.857 144.119 673.184 145.593C674.511 147.067 676.786 147.172 678.26 145.846C679.734 144.519 679.84 142.246 678.513 140.772Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.09
  }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M669.625 143.888C669.751 141.909 671.457 140.393 673.437 140.519C675.417 140.645 676.934 142.351 676.807 144.33C676.681 146.309 674.975 147.825 672.995 147.699C671.015 147.572 669.499 145.867 669.625 143.888Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.4
  }, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M644.182 372.267L666.803 355.023L606.628 211.241L583.797 372.267H582.197L605.87 205.283L668.509 354.981L668.74 355.549L646.815 372.267H644.182Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.29
  }, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M582.196 372.267L605.302 209.325L434.236 252.466L532.616 372.267H530.552L431.413 251.54L607.197 207.199L583.797 372.267H582.196Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.11
  }, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M608.545 208.968L497.654 126.56L457.867 209.831L459.3 210.526L498.264 128.981L603.954 207.536L460.5 212.336L460.542 213.937L608.545 208.968Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.39
  }, _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M460.584 209.536C458.604 209.599 457.046 211.262 457.109 213.241C457.172 215.221 458.836 216.779 460.816 216.715C462.796 216.652 464.354 214.989 464.291 213.01C464.228 211.031 462.564 209.473 460.584 209.536Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.16
  }, _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M461.89 211.558C461.027 213.347 458.878 214.105 457.088 213.242C455.298 212.379 454.539 210.231 455.403 208.441C456.267 206.652 458.415 205.894 460.205 206.757C461.995 207.62 462.754 209.768 461.89 211.558Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.36
  }, _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M613.642 207.199L460.5 212.337L460.542 213.937L598.857 209.305L434.552 250.74L455.972 216.569L454.624 215.726L431.098 253.267L613.642 207.199Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.53
  }, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M460.584 209.536C458.604 209.599 457.046 211.262 457.109 213.241C457.172 215.221 458.836 216.779 460.816 216.715C462.796 216.652 464.354 214.989 464.291 213.01C464.228 211.031 462.564 209.473 460.584 209.536Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.34
  }, _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M452.138 214.4C453.192 212.715 455.403 212.21 457.088 213.263C458.773 214.315 459.279 216.526 458.225 218.21C457.172 219.895 454.961 220.4 453.276 219.347C451.591 218.295 451.085 216.084 452.138 214.4Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M239.623 372.267L270.478 325.083L271.826 325.968L241.518 372.267H239.623Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M330.526 372.267L275.112 325.483L276.144 324.262L332.99 372.267H330.526Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.65
  }, _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M278.082 322.241C276.565 320.956 274.291 321.146 273.006 322.662C271.721 324.178 271.911 326.452 273.427 327.736C274.944 329.02 277.218 328.831 278.503 327.315C279.788 325.799 279.598 323.525 278.082 322.241Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.13
  }, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M268.035 323.714C269.131 322.051 271.342 321.588 273.006 322.683C274.67 323.778 275.133 325.988 274.038 327.652C272.943 329.315 270.731 329.778 269.067 328.683C267.403 327.588 266.94 325.378 268.035 323.714Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.26
  }, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M226.122 372.267L238.043 336.011L239.559 336.495L227.807 372.267H226.122Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.26
  }, _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M239.623 372.267L271.131 324.094L243.372 332.747L242.908 331.231L274.901 321.251L241.518 372.267H239.623Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.6
  }, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M242.171 337.547C242.782 335.652 241.771 333.631 239.875 333C237.98 332.368 235.958 333.4 235.326 335.295C234.715 337.189 235.726 339.211 237.622 339.842C239.517 340.453 241.539 339.442 242.171 337.547Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.67
  }, _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M244.383 335.379C242.487 335.969 240.465 334.916 239.875 333.021C239.286 331.126 240.339 329.105 242.234 328.516C244.13 327.926 246.152 328.979 246.742 330.874C247.331 332.769 246.278 334.79 244.383 335.379Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.34
  }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3613 372.267L38.733 346.391L40.2495 346.833L33.0042 372.267H31.3613Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.34
  }, _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4644 372.267L42.5242 346.138L43.5563 344.917L75.9286 372.267H73.4644Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.46
  }, _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9033 347.759C43.4509 345.843 42.3347 343.864 40.4391 343.317C38.5224 342.769 36.5426 343.885 35.995 345.78C35.4474 347.696 36.5637 349.675 38.4592 350.222C40.3548 350.77 42.3557 349.654 42.9033 347.759Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.2
  }, _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8603 348.39C39.3439 347.106 39.1543 344.832 40.4391 343.316C41.7239 341.8 43.9986 341.611 45.5151 342.895C47.0315 344.179 47.2211 346.453 45.9363 347.969C44.6515 349.485 42.3768 349.675 40.8603 348.39Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.02
  }, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3614 372.267L39.0069 345.359L2.67489 372.267H0L41.8292 341.295L33.0042 372.267H31.3614Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.3
  }, _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M374.967 372.267L376.61 358.139L276.713 324.746L332.99 372.267H330.526L275.112 325.483L276.06 324.368L276.502 322.999L378.337 357.044L376.568 372.267H374.967Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.28
  }, _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M277.576 320.388C275.702 319.757 273.659 320.767 273.027 322.662C272.395 324.536 273.406 326.578 275.302 327.21C277.197 327.842 279.219 326.831 279.851 324.936C280.483 323.062 279.472 321.02 277.576 320.388Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.68
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M273.448 327.736C271.932 326.452 271.742 324.178 273.027 322.662C274.312 321.146 276.586 320.956 278.103 322.241C279.619 323.525 279.809 325.799 278.524 327.315C277.239 328.831 274.965 329.02 273.448 327.736Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.03
  }, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M179.68 372.267L162.62 350.37L163.884 349.401L181.681 372.267H179.68Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.03
  }, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M195.961 372.267L187.241 350.033L164.516 348.264L164.621 346.664L188.358 348.517L197.667 372.267H195.961Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.14
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M166.2 347.822C164.979 346.264 162.725 345.969 161.146 347.19C159.587 348.412 159.292 350.664 160.514 352.244C161.735 353.802 163.989 354.096 165.569 352.875C167.127 351.654 167.422 349.401 166.2 347.822Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.63
  }, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M164.473 351.065C162.493 350.917 161.019 349.191 161.167 347.191C161.314 345.211 163.041 343.738 165.042 343.885C167.022 344.032 168.496 345.78 168.349 347.759C168.201 349.738 166.453 351.212 164.494 351.065H164.473Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.06
  }, _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M179.68 372.267L162.725 350.517L167.654 372.267H166.032L161.146 350.707L162.662 350.349L163.884 349.401L181.681 372.267H179.68Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.63
  }, _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M166.2 347.822C164.979 346.264 162.725 345.969 161.146 347.19C159.587 348.412 159.292 350.664 160.514 352.244C161.735 353.802 163.989 354.096 165.569 352.875C167.127 351.654 167.422 349.401 166.2 347.822Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.24
  }, _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M158.45 351.507C158.007 349.57 159.229 347.654 161.167 347.212C163.104 346.77 165.021 347.991 165.463 349.928C165.906 351.865 164.684 353.781 162.746 354.223C160.809 354.665 158.892 353.444 158.45 351.507Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.13
  }, _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6927 344.201L75.9286 372.267H73.4643L38.1644 342.453L157.776 346.285L157.712 347.885L42.6927 344.201Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.13
  }, _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M166.032 372.267L161.146 350.707L162.683 350.349L167.654 372.267H166.032Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.44
  }, _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M165.463 349.907C165.021 347.97 163.104 346.749 161.167 347.191C159.229 347.633 158.007 349.549 158.45 351.486C158.892 353.423 160.809 354.644 162.746 354.202C164.684 353.76 165.906 351.844 165.463 349.907Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.17
  }, _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M157.67 343.485C159.65 343.548 161.209 345.212 161.145 347.191C161.082 349.17 159.418 350.728 157.439 350.665C155.459 350.601 153.9 348.938 153.963 346.959C154.026 344.98 155.69 343.422 157.67 343.485Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.43
  }, _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M210.852 372.267H209.251L207.377 347.612L236.442 333.758L237.137 335.211L209.041 348.58L210.852 372.267Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.43
  }, _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M226.122 372.267L238.043 336.011L239.559 336.495L227.807 372.267H226.122Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.47
  }, _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M242.171 337.547C242.782 335.652 241.771 333.631 239.875 333C237.98 332.368 235.958 333.4 235.326 335.295C234.715 337.189 235.726 339.211 237.622 339.842C239.517 340.453 241.539 339.442 242.171 337.547Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.05
  }, _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M235.073 331.316C236.863 330.452 239.012 331.231 239.875 333.021C240.739 334.811 239.96 336.958 238.169 337.822C236.379 338.685 234.231 337.906 233.367 336.116C232.504 334.327 233.283 332.179 235.073 331.316Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.06
  }, _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M209.251 372.267L207.672 351.57L209.272 351.444L210.852 372.267H209.251Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.06
  }, _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M197.667 372.267H195.961L186.652 348.538L204.765 347.485L204.849 349.086L188.926 350.012L197.667 372.267Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.39
  }, _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M212.073 351.402C211.926 349.422 210.199 347.949 208.219 348.096C206.239 348.243 204.765 349.97 204.912 351.949C205.06 353.928 206.787 355.402 208.767 355.254C210.747 355.107 212.221 353.381 212.073 351.402Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.69
  }, _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M204.407 344.706C206.387 344.601 208.093 346.096 208.198 348.096C208.303 350.096 206.808 351.781 204.807 351.886C202.827 351.991 201.121 350.496 201.016 348.496C200.911 346.496 202.406 344.812 204.407 344.706Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.43
  }, _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M779 138.962L774.998 141.699L779 133.34V138.962Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.23
  }, _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M605.765 208.884L606.818 207.705L516.883 114.307L515.746 115.402L599.004 201.873L499.191 127.697L512.039 115.338L510.923 114.18L496.727 127.845L497.485 128.413L605.765 208.884Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.32
  }, _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M519.032 112.496C517.662 111.064 515.388 111.022 513.956 112.391C512.523 113.759 512.481 116.033 513.85 117.465C515.219 118.897 517.515 118.939 518.926 117.57C520.358 116.202 520.401 113.907 519.032 112.496Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.11
  }, _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M508.859 112.285C510.291 110.917 512.566 110.959 513.935 112.391C515.304 113.822 515.261 116.096 513.829 117.465C512.397 118.833 510.122 118.791 508.753 117.359C507.384 115.928 507.426 113.654 508.859 112.285Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.24
  }, _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M432.593 253.898L455.972 216.568L454.624 215.726L433.077 250.108L426.401 228.759L454.371 215.431L453.676 214L424.463 227.917L432.593 253.898Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.3
  }, _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M458.246 218.21C459.299 216.526 458.794 214.315 457.109 213.263C455.424 212.21 453.212 212.715 452.159 214.4C451.106 216.084 451.612 218.295 453.297 219.347C454.982 220.4 457.193 219.895 458.246 218.21Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.03
  }, _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M452.307 211.557C454.097 210.694 456.246 211.473 457.109 213.263C457.973 215.052 457.193 217.2 455.403 218.063C453.613 218.927 451.464 218.147 450.601 216.358C449.737 214.568 450.517 212.421 452.307 211.557Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.12
  }, _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M433.836 252.529L427.222 231.349L425.706 231.833L431.835 251.477L415.238 256.656L424.947 231.812L423.452 231.222L412.542 259.162L433.836 252.529Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.58
  }, _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M429.939 230.696C429.349 228.801 427.327 227.748 425.432 228.338C423.536 228.927 422.483 230.949 423.073 232.843C423.663 234.738 425.685 235.791 427.58 235.202C429.476 234.612 430.529 232.591 429.939 230.696Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.32
  }, _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M420.777 230.38C421.493 228.527 423.578 227.622 425.432 228.338C427.285 229.053 428.191 231.138 427.475 232.991C426.759 234.843 424.674 235.749 422.82 235.033C420.967 234.317 420.061 232.233 420.777 230.38Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.48
  }, _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M530.552 372.267L435.689 256.719L484.237 372.267H482.489L429.981 247.266L532.616 372.267H530.552Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.28
  }, _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M482.51 372.267L433.414 255.456L434.888 254.845L484.237 372.267H482.51Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.28
  }, _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M429.939 372.267H427.475L392.933 342.832L392.491 342.432L430.739 254.803L432.193 255.456L394.429 341.99L429.939 372.267Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.25
  }, _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M434.699 256.74C435.499 254.93 434.657 252.803 432.846 252.003C431.034 251.203 428.907 252.045 428.107 253.856C427.306 255.667 428.149 257.793 429.96 258.593C431.771 259.393 433.899 258.551 434.699 256.74Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.57
  }, _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M430.908 256.699C430.129 254.867 430.992 252.761 432.825 251.982C434.657 251.203 436.763 252.067 437.542 253.898C438.301 255.73 437.458 257.835 435.626 258.614C433.793 259.394 431.687 258.53 430.908 256.699Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.23
  }, _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M723.86 372.267L724.892 359.065L703.05 365.887L704.588 372.267H702.945L701.323 365.529L701.155 364.813L726.661 356.855L725.46 372.267H723.86Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.15
  }, _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M702.945 372.267L701.429 365.992L669.562 356.644L679.356 372.267H677.481L665.981 353.928L702.313 364.582L702.756 364.708L704.588 372.267H702.945Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.43
  }, _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M677.481 372.267L667.561 356.455L646.814 372.267H644.182L667.287 354.644L667.982 354.118L679.355 372.267H677.481Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.65
  }, _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M779 76.0079L708.821 114.348L776.599 138.371L779 133.339V137.045L777.42 140.351L704.925 114.664L779 74.1972V76.0079Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.03
  }, _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M414.416 258.762L424.947 231.812L423.452 231.222L413.363 257.056L379.032 253.54L422.778 230.612L422.041 229.201L373.598 254.572L414.416 258.762Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.28
  }, _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M427.475 232.991C428.191 231.138 427.285 229.053 425.432 228.338C423.578 227.622 421.493 228.527 420.777 230.38C420.061 232.233 420.967 234.317 422.82 235.033C424.674 235.749 426.759 234.843 427.475 232.991Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.07
  }, _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M420.588 226.822C422.357 225.895 424.526 226.569 425.432 228.338C426.359 230.106 425.685 232.275 423.915 233.18C422.146 234.107 419.977 233.433 419.071 231.664C418.144 229.896 418.839 227.727 420.588 226.822Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.3
  }, _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M393.375 345.948L414.88 257.203L379.79 253.624L379.622 255.203L412.9 258.614L393.544 338.474L377.747 257.267L376.189 257.561L393.375 345.948Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.6
  }, _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M380.254 250.845C378.274 250.634 376.505 252.087 376.315 254.045C376.104 256.024 377.558 257.793 379.517 257.982C381.496 258.193 383.266 256.74 383.455 254.782C383.666 252.803 382.212 251.034 380.254 250.845Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.48
  }, _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M376.694 359.444L394.323 342.495L394.239 342.074L377.747 257.267L376.652 257.477H375.557L376.694 359.444ZM392.596 341.948L378.253 355.739L377.22 262.825L392.596 341.927V341.948Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.1
  }, _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M380.527 256.908C380.148 254.95 378.253 253.687 376.315 254.066C374.356 254.445 373.093 256.34 373.472 258.277C373.851 260.235 375.746 261.498 377.684 261.119C379.622 260.74 380.907 258.846 380.527 256.908Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.22
  }, _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M372.756 257.688C372.735 255.709 374.335 254.066 376.315 254.045C378.295 254.024 379.938 255.624 379.959 257.603C379.98 259.583 378.379 261.225 376.399 261.246C374.42 261.267 372.777 259.667 372.756 257.688Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.04
  }, _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M378.274 358.707L377.137 257.456L375.557 257.477L376.673 356.475L274.817 322.43L373.914 256.614L373.03 255.287L271.216 322.893L378.274 358.707Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.24
  }, _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M379.938 257.603C379.917 255.624 378.295 254.024 376.294 254.045C374.314 254.066 372.714 255.687 372.735 257.688C372.756 259.667 374.378 261.267 376.378 261.246C378.358 261.225 379.959 259.604 379.938 257.603Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.08
  }, _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M371.324 253.056C372.988 251.961 375.22 252.403 376.315 254.066C377.411 255.73 376.968 257.961 375.304 259.056C373.64 260.151 371.429 259.709 370.313 258.046C369.217 256.382 369.66 254.151 371.324 253.056Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.54
  }, _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M636.452 228.59L674.532 140.014L642.623 130.666L642.16 132.182L672.342 141.046L638.2 220.484L639.843 133.887L638.242 133.866L636.452 228.59Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.69
  }, _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M642.644 134.119C642.687 132.14 641.107 130.497 639.127 130.455C637.147 130.413 635.504 131.992 635.462 133.971C635.42 135.951 637 137.593 638.98 137.635C640.959 137.677 642.602 136.098 642.644 134.119Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.21
  }, _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M641.549 134.919C639.654 134.35 638.558 132.371 639.106 130.455C639.675 128.56 641.655 127.466 643.571 128.013C645.467 128.581 646.562 130.561 646.014 132.477C645.467 134.393 643.466 135.466 641.549 134.919Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.19
  }, _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M667.308 253.477L674.027 143.972L672.658 143.888L671.373 143.341L636.389 224.717L636.81 225.096L667.329 253.456L667.308 253.477ZM672.363 145.046L665.918 250.024L638.285 224.338L672.363 145.067V145.046Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.64
  }, _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M676.807 144.33C676.934 142.351 675.417 140.645 673.437 140.519C671.457 140.393 669.751 141.909 669.625 143.888C669.499 145.867 671.015 147.572 672.995 147.699C674.975 147.825 676.681 146.309 676.807 144.33Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.02
  }, _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M668.719 142.414C669.498 140.582 671.626 139.74 673.437 140.54C675.269 141.319 676.112 143.446 675.312 145.256C674.532 147.088 672.405 147.93 670.594 147.13C668.761 146.351 667.919 144.225 668.719 142.414Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.64
  }, _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M638.095 225.833L639.843 133.887H638.39L637.042 133.298L605.217 208.61L638.074 225.833H638.095ZM638.242 134.582L636.557 223.222L607.281 207.894L638.242 134.582Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.26
  }, _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M635.441 133.992C635.483 132.013 637.126 130.434 639.106 130.476C641.086 130.518 642.665 132.161 642.623 134.14C642.581 136.119 640.938 137.698 638.959 137.656C636.979 137.614 635.399 135.972 635.441 133.992Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.03
  }, _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M668.656 362.582L667.456 255.161L665.855 255.182L666.887 347.991L638.685 226.885L663.559 250.003L664.654 248.845L635.947 222.169L668.656 362.582Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.37
  }, _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M666.423 246.676C667.877 248.023 667.961 250.297 666.613 251.75C665.265 253.203 662.99 253.287 661.537 251.94C660.084 250.592 660 248.318 661.348 246.865C662.695 245.413 664.97 245.328 666.423 246.676Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.69
  }, _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M667.771 351.78L638.011 224L604.648 206.525L605.512 208.567L665.707 352.454L666.697 352.033L667.75 351.78H667.771ZM636.621 225.074L664.844 346.222L607.85 209.999L636.642 225.074H636.621Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.42
  }, _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M663.075 353.36C663.833 355.191 665.939 356.054 667.771 355.297C669.604 354.539 670.467 352.433 669.709 350.601C668.951 348.77 666.845 347.906 665.012 348.664C663.18 349.422 662.316 351.528 663.075 353.36Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.37
  }, _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M670.467 350.959C670.91 352.896 669.709 354.833 667.772 355.276C665.834 355.718 663.896 354.518 663.454 352.581C663.012 350.644 664.212 348.707 666.15 348.264C668.087 347.822 670.025 349.022 670.467 350.959Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.6
  }, _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M769.333 248.087L777.863 138.645L777.083 138.561L689.634 130.855L689.508 132.455L776.157 140.077L768.069 243.623L688.812 133.655L687.507 134.603L769.333 248.087Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.41
  }, _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M690.055 128.097C688.075 127.928 686.327 129.381 686.159 131.36C685.99 133.339 687.443 135.087 689.423 135.255C691.403 135.424 693.151 133.971 693.32 131.992C693.488 130.013 692.035 128.265 690.055 128.097Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.15
  }, _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M685.358 136.372C684.2 134.772 684.558 132.519 686.18 131.361C687.78 130.203 690.034 130.561 691.192 132.182C692.351 133.782 691.993 136.035 690.371 137.193C688.749 138.351 686.517 137.993 685.358 136.372Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.18
  }, _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M779 140.33L689.507 132.455L689.634 130.855L770.828 138.014L707.031 115.401L689.318 129.823L688.307 128.581L706.715 113.611L779 139.214V140.33Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.68
  }, _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M690.055 128.097C688.075 127.928 686.327 129.381 686.159 131.36C685.99 133.339 687.443 135.087 689.423 135.255C691.403 135.424 693.151 133.971 693.32 131.992C693.488 130.013 692.035 128.265 690.055 128.097Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M691.214 131.887C689.676 133.15 687.401 132.897 686.159 131.36C684.895 129.823 685.148 127.549 686.685 126.307C688.223 125.044 690.497 125.297 691.74 126.834C693.004 128.371 692.751 130.644 691.214 131.887Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.37
  }, _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M691.192 132.181C690.034 130.581 687.78 130.202 686.18 131.36C684.579 132.518 684.2 134.771 685.358 136.371C686.516 137.971 688.77 138.35 690.371 137.192C691.972 136.034 692.351 133.782 691.192 132.181Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.29
  }, _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M681.146 130.539C682.746 129.381 685 129.739 686.158 131.361C687.317 132.961 686.959 135.214 685.337 136.372C683.736 137.53 681.483 137.172 680.324 135.55C679.166 133.95 679.524 131.697 681.146 130.539Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.49
  }, _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M385.035 372.267H383.287L376.505 357.402L390.448 344.011L391.543 345.148L378.442 357.781L385.035 372.267Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.49
  }, _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M398.493 372.267L393.333 345.717L394.892 345.422L400.115 372.267H398.493Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.52
  }, _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M393.354 347.296C394.786 345.927 394.829 343.653 393.46 342.222C392.091 340.79 389.795 340.748 388.384 342.116C386.951 343.485 386.909 345.759 388.278 347.19C389.647 348.622 391.943 348.664 393.354 347.296Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.48
  }, _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M390.616 346.433C390.237 344.475 391.501 342.601 393.46 342.222C395.418 341.843 397.293 343.106 397.672 345.064C398.051 347.022 396.787 348.896 394.829 349.275C392.87 349.654 390.995 348.391 390.616 346.433Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.22
  }, _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M383.265 372.267L378.168 361.023L379.622 360.371L385.035 372.267H383.265Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.22
  }, _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M374.967 372.267L376.294 360.897L377.874 361.066L376.568 372.267H374.967Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.24
  }, _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M380.633 361.571C380.865 359.592 379.453 357.823 377.474 357.592C375.494 357.36 373.725 358.771 373.493 360.75C373.261 362.729 374.672 364.497 376.652 364.729C378.632 364.961 380.401 363.55 380.633 361.571Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.29
  }, _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M375.683 362.35C374.862 360.539 375.662 358.412 377.473 357.591C379.285 356.77 381.412 357.57 382.233 359.381C383.055 361.192 382.254 363.318 380.443 364.139C378.632 364.96 376.505 364.16 375.683 362.35Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.49
  }, _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M606.144 210.568L606.986 208.568L638.516 133.908L637.042 133.298L606.355 205.936L569.222 87.0198L635.799 129.297L636.663 127.95L566.4 83.3563L606.144 210.568Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.11
  }, _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M641.023 135.172C641.802 133.34 640.938 131.234 639.106 130.455C637.274 129.676 635.167 130.54 634.388 132.371C633.609 134.203 634.472 136.309 636.305 137.088C638.137 137.867 640.243 137.003 641.023 135.172Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.65
  }, _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M638.011 125.507C639.696 126.581 640.18 128.792 639.127 130.476C638.053 132.16 635.841 132.645 634.156 131.592C632.472 130.518 631.987 128.307 633.04 126.623C634.114 124.939 636.326 124.454 638.011 125.507Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.09
  }, _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M608.018 211.241L569.58 88.1984L568.064 88.6827L604.48 205.262L515.261 112.622L565.115 87.4405L564.399 86.0088L512.629 112.159L513.366 112.938L608.018 211.241Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.65
  }, _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M572.319 87.546C571.729 85.6511 569.707 84.5983 567.811 85.1879C565.916 85.7774 564.863 87.7986 565.452 89.6935C566.042 91.5884 568.064 92.6412 569.96 92.0517C571.855 91.4621 572.908 89.4409 572.319 87.546Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.25
  }, _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M562.967 83.6092C564.736 82.7038 566.905 83.4197 567.79 85.1883C568.674 86.9568 567.979 89.1255 566.21 90.0098C564.441 90.9151 562.271 90.1993 561.387 88.4307C560.481 86.6621 561.197 84.4935 562.967 83.6092Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.24
  }, _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M731.084 372.267H729.399L724.807 357.528L779 332.137V333.905L726.745 358.392L731.084 372.267Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.37
  }, _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M729.399 372.267L726.24 362.139L725.46 372.267H723.86L725.292 353.781L731.084 372.267H729.399Z",
    fill: "#5CBF14"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrityBgImg);
export default __webpack_public_path__ + "static/media/integrity-bg-img.182fde617baef3d8fd89c3c13e5b0db7.svg";
export { ForwardRef as ReactComponent };